import { useEffect } from 'react';

export default function SlyderWidget() {
  useEffect(() => {
    // Prevent multiple injections
    if (document.getElementById('slyder-injected-script')) return;

    const scriptContent = `
      (function() {
        var open = false;
        var isMobile = window.innerWidth < 768;
        var zapIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>';
        var closeIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
        var btnBase = 'position:fixed;bottom:20px;right:20px;width:56px;height:56px;border-radius:50%;background:linear-gradient(135deg,#7c3aed,#ec4899);border:none;cursor:pointer;z-index:2147483647;box-shadow:0 4px 16px rgba(124,58,237,.45);display:flex;align-items:center;justify-content:center;outline:none;transition:transform .15s,box-shadow .15s';

        var panel = document.createElement('div');
        panel.id = 'slyder-custom-panel';
        panel.style.cssText = 'position:fixed;bottom:88px;right:20px;width:390px;height:640px;border-radius:24px;overflow:hidden;box-shadow:0 16px 48px rgba(0,0,0,.35);z-index:2147483646;display:none;border:1px solid rgba(255,255,255,.07)';

        var iframe = document.createElement('iframe');
        iframe.src = 'https://slyder.io/embed-panel/salon' + (isMobile ? '?mobile=1' : '');
        iframe.setAttribute('frameborder','0');
        iframe.setAttribute('allow','autoplay; fullscreen');
        iframe.style.cssText = 'width:100%;height:100%;border:none;display:block';
        panel.appendChild(iframe);

        var btn = document.createElement('button');
        btn.id = 'slyder-custom-btn';
        btn.setAttribute('aria-label','Open Slyder');
        btn.style.cssText = btnBase;
        btn.innerHTML = zapIcon;
        btn.onmouseover = function(){ btn.style.transform='scale(1.08)'; btn.style.boxShadow='0 6px 24px rgba(124,58,237,.6)'; };
        btn.onmouseout  = function(){ btn.style.transform='scale(1)';    btn.style.boxShadow='0 4px 16px rgba(124,58,237,.45)'; };

        btn.onclick = function() {
          open = !open;
          if (open) {
            if (isMobile) {
              panel.style.cssText = 'position:fixed;inset:0;z-index:2147483646;display:block;border-radius:0';
              btn.style.display = 'none';
            } else {
              panel.style.cssText = 'position:fixed;bottom:88px;right:20px;width:390px;height:640px;border-radius:24px;overflow:hidden;box-shadow:0 16px 48px rgba(0,0,0,.35);z-index:2147483646;display:block;border:1px solid rgba(255,255,255,.07)';
              btn.innerHTML = closeIcon;
              btn.setAttribute('aria-label','Close Slyder');
            }
          } else {
            panel.style.display = 'none';
            btn.style.cssText = btnBase;
            btn.innerHTML = zapIcon;
            btn.setAttribute('aria-label','Open Slyder');
          }
        };

        window.addEventListener('message', function(e) {
          if (!e.data || typeof e.data.type !== 'string') return;
          if (e.data.type === 'slyder-embed-close') {
            open = false;
            panel.style.display = 'none';
            btn.style.cssText = btnBase;
            btn.innerHTML = zapIcon;
            btn.setAttribute('aria-label', 'Open Slyder');
          }
        });

        document.body.appendChild(panel);
        document.body.appendChild(btn);
      })();
    `;

    const script = document.createElement('script');
    script.id = 'slyder-injected-script';
    script.innerHTML = scriptContent;
    document.body.appendChild(script);

    return () => {
      // Cleanup on unmount to prevent duplicates during HMR or strict mode
      const existingScript = document.getElementById('slyder-injected-script');
      const panel = document.getElementById('slyder-custom-panel');
      const btn = document.getElementById('slyder-custom-btn');
      
      if (existingScript) existingScript.remove();
      if (panel) panel.remove();
      if (btn) btn.remove();
    };
  }, []);

  return null;
}